import {
  Button,
  TablePagination,
  Typography
} from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { DatePicker } from "antd";
import { buildApiUrl } from "api/farmApi";
import axios from "axios";
import DrawerFilter from "components/DrawerFilter/DrawerFilter";
import FilterIcon from "components/icons/FilterIcon";
import LoadingComponent from "components/loading/Loading";
import { BASE_URL, TOKEN } from "constants/config";
import {
  fetchDetailResult,
  selectDetailResultList,
  selectFilterDetailResult,
  selectLoading,
  setFilterDetailResult
} from "features/Admin/adminSlice";
import FileDownload from "js-file-download";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

const { RangePicker } = DatePicker;

const useStyles = makeStyles({
  table: {
    minWidth: 700,
    overflowX: "auto",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    marginBottom: 12,
  },

  tabItem: {
    padding: 8,
    borderRadius: 6,
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    color: "#000",
    background: "#ECEDF2",
    marginRight: 4,
    minWidth: 120,
    cursor: "pointer",
  },
  active: {
    background: "#4350B0",
    color: "#fff",
  },
  stickyCol: {
    position: "sticky",
    left: 0,
    background: "#ECEDF2",
    zIndex: 800,
    fontWeight: "bold",
  },
  filter: {
    display: "flex",
    alignItems: "center",
    gap: "0px 12px",
  },
  filterIcon: {
    cursor: "pointer",
  },
  btn_export: {
    background: "#F65C00",
    color: "#fff",
    borderRadius: 6,
    textTransform: "capitalize",
    "&:hover": {
      background: "#F65C00",
      opacity: 0.8,
    },
  },
});

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#eaedf4",
    color: theme.palette.common.black,
    borderRight: "1px solid rgba(224, 224, 224, 1)",
    minWidth: 125,
    fontWeight:700
  },
  body: {
    fontSize: 14,
    borderRight: "1px solid rgba(224, 224, 224, 1)",
  },
}))(TableCell);

const columns = [
  { id: "stt", label: "STT", minWidth: 20, align: "center" },
  { id: "name", label: "Tên trại", minWidth: 100 , align: "center",},
  {
    id: "province",
    label: "Tỉnh",
    minWidth: 100,
    format: (value) => value.toLocaleString("en-US"),
    align: "center",
  },
  {
    id: "createTime",
    label: "Ngày kiểm tra",
    minWidth: 100,
    format: (value) => value.toFixed(2),
    align: "center",
  },
  {
    id: "type",
    label: "Hình thức tiếp cận",
    minWidth: 120,
    format: (value) => value.toFixed(2),
    align: "center",
  },
  {
    id: "type-test",
    label: "Hình thức kiểm tra",
    minWidth: 120,
    format: (value) => value.toFixed(2),
    align: "center",
  },
  {
    id: "total-point",
    label: "Tổng điểm",
    minWidth: 120,
    format: (value) => value.toFixed(2),
    align: "center",
  },
  {
    id: "result",
    label: "Kết quả",
    minWidth: 90,
    format: (value) => value.toFixed(2),
    align: "center",
  },
];

export default function DetailResultPage() {
  const dateFormat = "DD/MM/YYYY";
  const classes = useStyles();
  const [openDrawerFilter, setOpenDrawerFilter] = useState(false);
  const listDetailResult = useSelector(selectDetailResultList);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [page, setPage] = useState(0);
  const filter = useSelector(selectFilterDetailResult);
  const loading = useSelector(selectLoading);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchDetailResult(filter));
  }, [dispatch, filter]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const onFilterDate = (date) => {
    dispatch(
      setFilterDetailResult({
        ...filter,
        fromDate: date ? moment(date[0]).format('YYYY/MM/DD').split('/').join('') : null,
        toDate: date ? moment(date[1]).format('YYYY/MM/DD').split('/').join('') : null
      })
    );
  };

  const onExportFile = async () => {
    const token = localStorage.getItem(TOKEN);
    try {
      const res = await axios({
        method: "GET",
        url: buildApiUrl(`${BASE_URL}/statisic/ketQuaChiTiet/export/excel`,filter),
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "blob",
        },
        responseType: "arraybuffer",
      });
      if (res.data.responseDescription) {
        toast.error('Xuất file thất bại');
        return;
      }
      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      FileDownload(blob, `report-repeatation-${new Date().getTime()}.xlsx`);
      toast.success('Xuất file thành công');
    } catch (error) {}
  };

  const onOpenFilterDrawer = () => {
    setOpenDrawerFilter(true);
  };


  const onFilter = (data) => {
    dispatch(
      setFilterDetailResult({
        ...filter,
        ...data,
      })
    );
    setOpenDrawerFilter(false);
  };

  return (
    <div>
      <div className={classes.header}>
        <div className={classes.filter}>
          <div className={classes.filterIcon} onClick={onOpenFilterDrawer}>
            <FilterIcon></FilterIcon>
          </div>
          <RangePicker
            format={dateFormat}
            onChange={onFilterDate}
            placeholder={["dd/mm/yyyy", "dd/mm/yyyy"]}
            allowClear
          />
          <Button
            onClick={onExportFile}
            className={classes.btn_export}
            variant="contained"
            color="primary"
          >
            Xuất File
          </Button>
        </div>
      </div>
      {loading ? (
        <LoadingComponent />
      ) : (
        <Paper>
          <TableContainer>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <StyledTableCell
                      key={column.id}
                      style={{ minWidth: column.minWidth }}
                      align={column.align}
                    >
                      {column.label}
                    </StyledTableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {listDetailResult.length > 0 ? (
                  listDetailResult?.slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage
                  )?.map((row, idx) => (
                    <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                      <StyledTableCell
                        align="center"
                        className={classes.tableCell}
                      >
                        {page * rowsPerPage + idx + 1}
                      </StyledTableCell>
                      <StyledTableCell
                        style={{
                          color: "#8f7bff",
                          fontSize: 15,
                        }}
                        align="center"
                        className={classes.tableCell}
                      >
                        {row.farmName}
                      </StyledTableCell>
                      <StyledTableCell
                        className={classes.tableCell}
                        align="center"
                      >
                        {row.provice}
                      </StyledTableCell>
                      <StyledTableCell
                        className={classes.tableCell}
                        align="center"
                      >
                        {row.testTime}
                      </StyledTableCell>
                      <StyledTableCell
                        className={classes.tableCell}
                        align="center"
                      >
                        {row.testTypeDesc}
                      </StyledTableCell>
                      <StyledTableCell
                        className={classes.tableCell}
                        align="center"
                      >
                        {row.testSubTypeDesc}
                      </StyledTableCell>
                      <StyledTableCell
                        className={classes.tableCell}
                        align="center"
                      >
                        {row.avgMark}%
                      </StyledTableCell>
                      <StyledTableCell
                        className={classes.tableCell}
                        align="center"
                      >
                        {row.result}
                      </StyledTableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell
                      style={{ height: 200 }}
                      align="center"
                      colSpan={12}
                    >
                      <Typography variant="body1" align="center">
                        No data available
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          {listDetailResult.length > 0 && (
            <TablePagination
              rowsPerPageOptions={[25, 50, 100]}
              component="div"
              count={listDetailResult?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
        </Paper>
      )}
      {openDrawerFilter && (
        <DrawerFilter
          onClose={() => setOpenDrawerFilter(false)}
          open={openDrawerFilter}
          onSubmit={onFilter}
          filter={filter}
          filterDetail={true}
        />
      )}
    </div>
  );
}
